import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { DateRange } from "./dateRange";
import { OccupationalRiskPreventionDirectKpiCfg, OccupationalRiskPreventionDirectKpiCfgService } from "./occupationalRiskPreventionDirectKpiCfg.service";
import { OccupationalRiskPreventionDirectKpiService } from "./occupationalRiskPreventionDirectKpiService";

export class FitWorkerDetail {
    public branchId: string;
    public userDocNumber: string;
    public userName: string;
    public workerId: number;
    public workerName: string;
    public workerPhone: string;
    public workerEmail: string;
    public examinationType: number;
    public examinationStatus: string;
    public examinationRequestDate: Date;
    public examinationDate: Date;
    public offerFiscalName: string;
    public clientId: number;
    public clientCenterId: number;
    public clientBranchId: string;
    public clientBranchName: string;
}

export class FitActiveWorkersWoMedicalExaminationDirectDetailServiceData {
    public workers: FitWorkerDetail[];
    public updateTimestamp: Date;
}

@Injectable()
export class FitActiveWorkersWoMedicalExaminationDirectDetailService extends OccupationalRiskPreventionDirectKpiService<FitActiveWorkersWoMedicalExaminationDirectDetailServiceData> {
    public getClassName() { return "FitActiveWorkersWoMedicalExaminationDirectDetailService"; }

    constructor(
        private serviceCfg: OccupationalRiskPreventionDirectKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<FitActiveWorkersWoMedicalExaminationDirectDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: FitActiveWorkersWoMedicalExaminationDirectDetailServiceData = null;
            try {
                let cfg: OccupationalRiskPreventionDirectKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDateRange(DateRange.CurrentWeek);
                let url = cfg.fitActiveWorkersWoMedicalExaminationDirect.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<FitActiveWorkersWoMedicalExaminationDirectDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
